import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import {
  loadCountries,
  loadCountriesFulfilled,
  loadCountriesRejected
} from '../features/countries.slice';
import { CountriesService } from '../services/countries.service';
import { languageChangedFulfilled } from '@core/modules/language/features/language.slice';

@Injectable()
export class CountriesEffects {
  loadCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCountries, languageChangedFulfilled),
      switchMap(() =>
        this.countriesService.getCountries().pipe(
          map((countries) => loadCountriesFulfilled(countries)),
          catchError(() => of(loadCountriesRejected()))
        )
      )
    )
  );

  constructor(private actions$: Actions, private countriesService: CountriesService) {}
}
